// src/components/ProjectModal.js
import React, { useEffect, useState, useRef } from 'react';
import {
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  Button,
  Row,
  Col,
  Radio,
  notification,
  DatePicker,
  Divider,
  Space,
  Typography,
  Upload,
} from 'antd';

import { connect } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';
import { DownOutlined, EditFilled, CheckOutlined, CloseOutlined, CloudUploadOutlined, CalendarOutlined } from '@ant-design/icons';
import { Button as CrcButton } from '@crc-evans/ui-components';
import { addCalibration, updateCalibration } from '../../redux/calibration/action';
import {
  AddOrUpdateCalibration,
  GetTableConfig,
  OnAddCalibration,
  OnUpdateCalibrationData,
} from '../../redux/calibration/saga';
//import { Contractor_List, countries_List, diameters, PipeDiaRate, Project_List, Representative_List, Spread_Config_List, Pipe_Grade_List } from './Database';
const { Option } = Select;

/**
 * Custom dropdown matching Heat Profile modal UI (same height, border-radius, theme).
 * Reused for Status and Location in calibration modal.
 */
const CustomSelect = ({
  value,
  onChange,
  options = [],
  placeholder = 'Select',
  disabled = false,
  className = '',
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const normalizedOptions = (options || [])
    .filter((opt) => opt != null && (typeof opt === 'string' ? opt !== '' : opt.value != null))
    .map((opt) =>
      typeof opt === 'string' ? { value: opt, label: opt } : { value: opt.value, label: opt.label ?? opt.value }
    );
  const selectedLabel = normalizedOptions.find((o) => o.value === value)?.label ?? value ?? '';

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  return (
    <div
      ref={containerRef}
      className={`heat-profile-custom-select ${className} ${open ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
    >
      <div
        className="heat-profile-custom-select-trigger"
        onClick={() => !disabled && setOpen((o) => !o)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') e.preventDefault();
          if (e.key === 'Escape') setOpen(false);
        }}
        role="combobox"
        aria-expanded={open}
        aria-haspopup="listbox"
        tabIndex={disabled ? -1 : 0}
      >
        <span className="heat-profile-custom-select-value">
          {selectedLabel || <span className="placeholder">{placeholder}</span>}
        </span>
        <DownOutlined className="heat-profile-custom-select-arrow" />
      </div>
      {open && (
        <div className="heat-profile-custom-select-dropdown" role="listbox">
          {normalizedOptions.map((opt) => (
            <div
              key={opt.value}
              className={`heat-profile-custom-select-option ${opt.value === value ? 'selected' : ''}`}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onChange(opt.value);
                  setOpen(false);
                }
              }}
              role="option"
              aria-selected={opt.value === value}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const ProjectModal = (props) => {
  const {
    isModalVisible,
    onClose,
    setIsModalVisible,
    projectDetailForm,
    isEdit,
    setIsEdit,
    editRecord,
    editValue,
    onAddCalibrationaction,
    onUpdateCalibration,
    isAddUpdateCalibration,
    fetchCalibrationData,
    rawDataList,
  } = props;
  const [newItem, setNewItem] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [reminderList, setReminderList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [frequency, setfrequency] = useState(12);
  const [uniqueLocations, setUniqueLocations] = useState([]);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [errorModalType, setErrorModalType] = useState(null); // 'SERIAL_NUMBER' or 'IDENTIFICATION'
  const [formData, setFormData] = useState({
    Instrument_Company: '',
    Identification: '',
    Code_Model: '',
    Manufacturer_Company: '',
    SerialNumber: '',
    Frequency: '',
    Status: 'Active/Calibrated',
    StorageArea: '',
    CertificateNumber: '',
    CalibrationDate: '',
    NextCalibrationDate: '',
    Expiration: '',
    Project: '',
    ProjectNo: '',
    Reminders: '',
    Location: '',
    Comments: '',
    RangeOfUse: '',
    PermissibleError: '',
    StandardCertificateNumber: '',
    NameLaboratory: '',
  });

  useEffect(() => {
    if (isEdit) {
      setFormData(editRecord);
      // console.log(editRecord)
      if (editRecord.Reminders) setReminderList(editRecord.Reminders.split(','));
    }

    if (uniqueLocations.length == 0) fetchData();
  }, []);
  const fetchData = async () => {
    const res = await GetTableConfig('UserManagement_DocControl');
    if (res && res.length > 0) {
      //console.log(res)
      // Remove duplicates based on the Location property
      const uniqueLocations = res.filter(
        (item, index, self) => self.findIndex((obj) => obj.Location === item.Location) === index
      );
      setUniqueLocations(uniqueLocations);
    }
  };

  const fileProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList,
  };

  const onchangechxBox = (isChecked, types) => {
    if (isChecked) setReminderList(types);
    else setReminderList([]);
  };

  const setAdddnewItem = (event) => {
    setNewItem(event.target.value);
  };

  const addItem = async (type, newItem) => {
    // console.log(type, newItem, categoryListdata)
    if (newItem) {
      // const newItem1 = { [tableNames[type]]: newItem }; // Example item
      // addItemToCategoryList(type, newItem1);
      // const obj = {
      //     tableName: type,
      //     data: [{
      //         [tableNames[type]]: newItem
      //     }]
      // };
      setNewItem('');
      // console.log(obj);
      // Uncomment and implement this function
      // await AddOrUpdateMasterData(obj)

      // const category = await getCategoryListFromDatabse();
      // if (category)
      //     setCategoryListdata(category)
      // console.log(category)
    }
  };

  const removeItem = (e) => {
    e.preventDefault();
    setNewItem('');
  };

  const handleInputChange = (name, value) => {
    if (name === 'CalibrationDate' || name == 'NextCalibrationDate' || name === 'Expiration')
      value = value ? moment(value).format('YYYY-MM-DD') : '';
    if (name === 'Frequency') value = `${value} months`;

    if (name === 'Location') {
      const isDuplicate = rawDataList?.some(
        (item) => item.Identification === formData.Identification && item.Location === value
      );

      if (isDuplicate) {
        notification.warning({
          message:
            'This Identification and Location already exist. Please enter a unique Identification number.',
        });
        // Clear the Location field
        //setFormData((prevData) => ({ ...prevData, Location: '' }));
        // return;
      }
    }
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleCancel = () => {
    projectDetailForm.resetFields();
    setIsEdit(false);

    setFormData({});
    //onClose();
    setIsModalVisible(false);
  };

  const getCategoryValue1 = (type) => {
    if (formData.hasOwnProperty(type)) {
      // Check if the category exists in selectedOptions
      return formData[type]; // Return the value for the category
    }
  };

  const handleOk = async () => {
    // Check for empty required fields in formData
    const requiredFields = {
      Instrument_Company: 'Instrument Company',
      Identification: 'Identification',
      Code_Model: 'Code Model',
      Manufacturer_Company: 'Manufacturer Company',
      // SerialNumber: 'Serial Number',
      Frequency: 'Frequency',
      Status: 'Status',
      StorageArea: 'Storage Area',
      CertificateNumber: 'Certificate Number',
      CalibrationDate: 'Calibration Date',
      NextCalibrationDate: 'Next Calibration Date',
      Expiration: 'Expiration',
      //Project: 'Project',
      // ProjectNo: 'Project Number',
      //  Reminders: 'Reminders',
      Location: 'Location',
    };
    setIsLoading(true);

    for (const field in requiredFields) {
      if (!formData[field]) {
        notification.warning({
          message: `Please fill the "${requiredFields[field]}" field to proceed!`,
        });
        setIsLoading(false);
        return;
      }
    }
    if (!isEdit) {
      const isDuplicate = rawDataList?.some(
        (item) =>
          item.Identification === formData.Identification && item.Location === formData.Location
      );

      if (isDuplicate) {
        notification.warning({
          message:
            'This Identification and Location already exist. Please enter a unique Identification number.',
        });
        setIsLoading(false);
        return;
      }
    }

    if (!isEdit && fileList.length == 0) {
      notification.warning({
        message: `Please select certificate to proceed!`,
      });
      setIsLoading(false);
      return;
    }

    if (!isEdit) formData['Created_Date'] = moment().format('YYYY-MM-DD').toString();

    formData['Updated_Date'] = moment().format('YYYY-MM-DD').toString();
    if (fileList && fileList.length > 0) formData['certificate'] = fileList;

    formData['Reminders'] = reminderList.toString();
    console.log('Project details', formData);
    formData['isEdit'] = isEdit;
    //console.log('Project details', formData)
    let res = false;
    if (isEdit) res = await OnUpdateCalibrationData({ data: formData });
    else res = await OnAddCalibration({ data: formData });
    
    // Check if it's a serial number or identification error
    if (res === 'SERIAL_NUMBER_ERROR') {
      setErrorModalType('SERIAL_NUMBER');
      setIsErrorModalVisible(true);
      setIsLoading(false);
      return;
    }
    
    // Check if it's an identification error (when serial number is empty and identification already exists)
    if (res === 'IDENTIFICATION_ERROR') {
      setErrorModalType('IDENTIFICATION');
      setIsErrorModalVisible(true);
      setIsLoading(false);
      return;
    }
    
    if (!res) {
      await fetchCalibrationData();

      setIsEdit(false);
      setIsModalVisible(false);
    }
    setIsLoading(false);
  };
  const extractNumber = (value) => {
    const match = value.match(/\d+/); // Match the first numeric part of the string
    return match ? parseInt(match[0], 10) : null; // Convert to number or return null if no number found
  };

  return (
    <>
    <Modal
      width={1000}
      visible={isModalVisible}
      title={isEdit ? 'Update Calibration' : 'New Calibration'}
      className="pipeline-modal trackrecord-modal Tracker-modal heatprofile-modal"
      footer={[
        <CrcButton
          key="back"
          label="Cancel"
          variant="tertiary"
          onClick={() => handleCancel()}
          size="medium"
        />,
        <CrcButton
          key="submit"
          label={isLoading ? (isEdit ? 'Updating…' : 'Submitting…') : (isEdit ? 'Update' : 'Submit')}
          variant="primary"
          onClick={async () => await handleOk()}
          loading={isLoading}
          size="medium"
        />,
      ]}
    >
      <Form
        form={projectDetailForm}
        name="project_form"
        layout="vertical"
        autoComplete="off"
        getcontainer={false}
        //onValuesChange={onValuesChange}
        width={1000}
      >
        <Row gutter={24}>
          <Col lg={6}>
            <Form.Item
              name="Instrument_Company"
              label="Instrument Name"
              required
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('Instrument_Company', e.target.value)}
                  size="large"
                  value={getCategoryValue1('Instrument_Company')}
                  placeholder="Enter Instrument Name"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="Identification"
              label="Identification"
              required
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('Identification', e.target.value)}
                  size="large"
                  value={getCategoryValue1('Identification')}
                  placeholder="Enter Identification"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="Code_Model"
              label="Code Model"
              required
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('Code_Model', e.target.value)}
                  size="large"
                  value={getCategoryValue1('Code_Model')}
                  placeholder="Enter Code Model"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="Manufacturer_Company"
              label="Manufacturer Company"
              required
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('Manufacturer_Company', e.target.value)}
                  size="large"
                  value={getCategoryValue1('Manufacturer_Company')}
                  placeholder="Manufacturer Company"
                />
              </div>
            </Form.Item>
          </Col>

          <Col lg={6}>
            <Form.Item
              name="SerialNumber"
              label="Serial Number"
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('SerialNumber', e.target.value)}
                  size="large"
                  value={getCategoryValue1('SerialNumber')}
                  placeholder="Enter Serial Number"
                />
              </div>
            </Form.Item>
          </Col>

          <Col lg={6}>
            <Form.Item
              name="Status"
              label="Status of Instrument"
              required
            >
              <div>
                <CustomSelect
                  value={formData['Status']}
                  onChange={(value) => handleInputChange('Status', value)}
                  options={['Active/Calibrated', 'On Hold', 'Out of Service', 'Retired']}
                  placeholder="Select Status"
                />
              </div>
            </Form.Item>
          </Col>

          <Col lg={6}>
            <Form.Item
              name="StorageArea"
              label="Storage Area"
              required
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('StorageArea', e.target.value)}
                  size="large"
                  value={getCategoryValue1('StorageArea')}
                  placeholder="Enter Storage Area"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="CertificateNumber"
              label="Certificate Number"
              required
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('CertificateNumber', e.target.value)}
                  size="large"
                  value={getCategoryValue1('CertificateNumber')}
                  placeholder="Enter Certificate Number"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={24}>
            <div
              style={{ marginBottom: '10px', marginTop: '-25px' }}
              required
            >
              <div className="heatp-bottom-border">&nbsp;</div>
            </div>
          </Col>

          <Col lg={6}>
            <Form.Item
              label="Frequency"
              name="Frequency"
              required
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Input
                  addonAfter="months"
                  className="Data360-addafter"
                  onChange={(e) => handleInputChange('Frequency', Number(e.target.value))}
                  value={extractNumber(getCategoryValue1('Frequency'))}
                  style={{ width: '100%', textAlign: 'left' }}
                  min={0}
                  type="number"
                  size="large"
                  placeholder="Enter Frequency"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="Project"
              label="Project Name"
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('Project', e.target.value)}
                  size="large"
                  value={getCategoryValue1('Project')}
                  placeholder="Enter Project"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="ProjectNo"
              label="Project No."
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('ProjectNo', e.target.value)}
                  size="large"
                  value={getCategoryValue1('ProjectNo')}
                  placeholder="Enter Project Number"
                />
              </div>
            </Form.Item>
          </Col>

          <Col lg={6}>
            <Form.Item
              name="Location"
              label="Location"
              required
            >
              <div>
                <CustomSelect
                  value={formData['Location'] || ''}
                  onChange={(value) => handleInputChange('Location', value)}
                  options={uniqueLocations ? uniqueLocations.map((item) => item.Location) : []}
                  placeholder="Select Location"
                />
              </div>
            </Form.Item>
          </Col>

          <Col lg={6}>
            <Form.Item
              name="CalibrationDate"
              label="Calibration Date"
              required
            >
              <div>
                <DatePicker
                  value={formData['CalibrationDate'] ? moment(formData['CalibrationDate']) : null}
                  onChange={(date) => handleInputChange('CalibrationDate', date)}
                  format="DD-MMM-YYYY"
                  placeholder="dd-mm-yyyy"
                  suffixIcon={<CalendarOutlined />}
                  dropdownClassName="heat-profile-datepicker-dropdown"
                  style={{ width: '100%' }}
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="NextCalibrationDate"
              label="NextCalibration Date"
              required
            >
              <div>
                <DatePicker
                  value={
                    formData['NextCalibrationDate'] ? moment(formData['NextCalibrationDate']) : null
                  }
                  onChange={(date) => handleInputChange('NextCalibrationDate', date)}
                  format="DD-MMM-YYYY"
                  placeholder="dd-mm-yyyy"
                  suffixIcon={<CalendarOutlined />}
                  dropdownClassName="heat-profile-datepicker-dropdown"
                  style={{ width: '100%' }}
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="Expiration"
              label="Expiration"
              required
            >
              <div>
                <DatePicker
                  value={formData['Expiration'] ? moment(formData['Expiration']) : null}
                  onChange={(date) => handleInputChange('Expiration', date)}
                  format="DD-MMM-YYYY"
                  placeholder="dd-mm-yyyy"
                  suffixIcon={<CalendarOutlined />}
                  dropdownClassName="heat-profile-datepicker-dropdown"
                  style={{ width: '100%' }}
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="RangeOfUse"
              label="Range of Use"
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('RangeOfUse', e.target.value)}
                  size="large"
                  value={getCategoryValue1('RangeOfUse')}
                  placeholder="Enter Range of Use"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="PermissibleError"
              label="Permissible Error"
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('PermissibleError', e.target.value)}
                  size="large"
                  value={getCategoryValue1('PermissibleError')}
                  placeholder="Enter Permissible Error"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="StandardCertificateNumber"
              label="Standard Certificate Number"
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('StandardCertificateNumber', e.target.value)}
                  size="large"
                  value={getCategoryValue1('StandardCertificateNumber')}
                  placeholder="Enter Standard Certificate Number"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item
              name="NameLaboratory"
              label="Name Laboratory"
            >
              <div>
                <Input
                  onChange={(e) => handleInputChange('NameLaboratory', e.target.value)}
                  size="large"
                  value={getCategoryValue1('NameLaboratory')}
                  placeholder="Enter Name Laboratory"
                />
              </div>
            </Form.Item>
          </Col>
          <Col lg={24}>
            <Form.Item
              name="Comments"
              label="Comments"
            >
              <div>
                <Input.TextArea
                  onChange={(e) => handleInputChange('Comments', e.target.value)}
                  size="large"
                  value={getCategoryValue1('Comments')}
                  placeholder="Enter Comments"
                />
              </div>
            </Form.Item>
          </Col>

          <Col lg={24}>
            <div style={{ marginBottom: '10px', marginTop: '-25px' }}>
              <div className="heatp-bottom-border">&nbsp;</div>
            </div>
          </Col>

          <Col lg={12}>
            <div style={{ paddingTop: '0px' }}>
              <Checkbox
                style={{ fontSize: '16px' }}
                checked={reminderList.length > 0}
                onChange={(e) => onchangechxBox(e.target.checked, ['90', '60', '30', '15'])}
              >
                Reminders{' '}
              </Checkbox>
              <Checkbox.Group
                style={{ display: 'block', paddingTop: '5px' }}
                onChange={(checkedValues) => {
                  setReminderList(checkedValues);
                }}
                value={reminderList}
              >
                <Checkbox
                  style={{ marginLeft: '15px' }}
                  value="15"
                >
                  15 Days
                </Checkbox>
                <Checkbox
                  style={{ marginLeft: '15px' }}
                  value="30"
                >
                  30 Days
                </Checkbox>
                <Checkbox
                  style={{ marginLeft: '15px' }}
                  value="60"
                >
                  60 Days
                </Checkbox>
                <Checkbox
                  style={{ marginLeft: '15px' }}
                  value="90"
                >
                  90 Days
                </Checkbox>
              </Checkbox.Group>
            </div>
          </Col>

          <Col lg={24}>
            <div style={{ marginBottom: '10px', marginTop: '-10px' }}>
              <div className="heatp-bottom-border">&nbsp;</div>
            </div>
          </Col>
        </Row>

        <div style={{ paddingTop: '20px' }}>
          <Col lg={8}>
            <Form.Item
              name="certificate"
              label="Upload Certificate"
              required
            >
              <Upload
                {...fileProps}
                maxCount={1}
                accept=".doc,.docx,application/pdf"
                className="calibration-upload-input-style"
              >
                <div className="calibration-upload-trigger">
                  <CloudUploadOutlined className="calibration-upload-icon" />
                  <span>Select File</span>
                </div>
              </Upload>
            </Form.Item>
          </Col>
          {isEdit &&
            editRecord.certificate_history &&
            editRecord.certificate_history.length > 0 && (
              <Form.Item>
                <ul>
                  {editRecord.certificate_history && editRecord.certificate_history.length > 0 ? (
                    (() => {
                      // Sort certificate_history by version in descending order
                      const sortedHistory = [...editRecord.certificate_history].sort((a, b) => {
                        const versionA = parseFloat(a.version) || 0;
                        const versionB = parseFloat(b.version) || 0;
                        return versionB - versionA; // Descending order
                      });
                      
                      // Find the highest version number
                      const highestVersion = sortedHistory.length > 0 
                        ? Math.max(...sortedHistory.map(item => parseFloat(item.version) || 0))
                        : null;
                      
                      return sortedHistory.map((item, i) => {
                        const currentVersion = parseFloat(item.version) || 0;
                        const isLatest = highestVersion !== null && currentVersion === highestVersion;
                        
                        return (
                          <li key={i}>
                            <a
                              href={item.certificateURL}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Certificate Version {item.version}{isLatest ? ' (latest)' : ''}
                            </a>
                          </li>
                        );
                      });
                    })()
                  ) : (
                    <li>No Certificate Uploaded</li>
                  )}
                </ul>
              </Form.Item>
            )}
        </div>
      </Form>
    </Modal>
    
    {/* Certificate Error Modal */}
    <Modal
      width="45vw"
      className="pipeline-modal"
      title="Certificate Already Exists"
      centered
      open={isErrorModalVisible}
      onCancel={() => {
        setIsErrorModalVisible(false);
        setErrorModalType(null);
      }}
      footer={[
        <Button 
          key="ok" 
          type="primary" 
          onClick={() => {
            setIsErrorModalVisible(false);
            setErrorModalType(null);
          }}
        >
          OK
        </Button>,
      ]}
    >
      <div>
        <Typography.Text style={{ fontSize: '16px' }}>
          {errorModalType === 'IDENTIFICATION' ? (
            <>
              <p>Certificate for this Identification already exists.</p>
              <p>You can click the edit button for this Identification and add the new certificate version.</p>
            </>
          ) : (
            <>
              <p>Certificate for this serial number already exists.</p>
              <p>You can click the edit button for this serial number and add the new certificate version.</p>
            </>
          )}
        </Typography.Text>
      </div>
    </Modal>
  </>
  );
};

const mapStateToProps = ({ calibrationReducer }) => {
  const isAddUpdateCalibration = get(calibrationReducer, 'isAddUpdateCalibration', false);
  return {
    isAddUpdateCalibration,
  };
};

const mapDispatchToProps = {
  onAddCalibrationaction: addCalibration,
  onUpdateCalibration: updateCalibration,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectModal);
